import { ref } from 'vue';
import { api } from '@/api';

/**
 * useEventosCounts — totales de eventos para los contadores de las pestañas.
 *
 * El listado de eventos pinta el número de eventos en cada tab ("Eventos
 * actuales", "Eventos pasados"). Los totales viven en su propio endpoint
 * (`GET /eventos/totales`) para que la paginación del listado no pague dos
 * COUNT por página: una petición ligera devuelve ambos contadores.
 *
 * Se pide al montar la vista y cada vez que un hijo avisa de una mutación
 * (`changed`), porque crear, borrar o cambiar de fecha un evento mueve los dos
 * contadores. Buscar o paginar no los mueve: el endpoint ignora esos filtros.
 *
 * @returns {{
 *   totalActuales: import('vue').Ref<number|null>,
 *   totalPasados: import('vue').Ref<number|null>,
 *   loading: import('vue').Ref<boolean>,
 *   fetchTotales: Function
 * }}
 */
export function useEventosCounts() {
    const totalActuales = ref(null);
    const totalPasados = ref(null);
    const loading = ref(false);

    async function fetchTotales() {
        loading.value = true;

        try {
            const token = localStorage.getItem('token');
            const res = await api.base().get('/eventos/totales', {
                params: token ? { api_key: token } : {}
            });
            const data = res && res.data ? res.data : {};

            if (typeof data.actuales === 'number') totalActuales.value = data.actuales;
            if (typeof data.pasados === 'number') totalPasados.value = data.pasados;
        } catch (error) {
            // Los badges no deben romper el listado: se dejan como estaban.
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    return {
        totalActuales,
        totalPasados,
        loading,
        fetchTotales
    };
}
